module.exports = __webpack_public_path__ + "static/img/db-life-smart-phone-sales-img-02-04@w.2349d9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/db-life-smart-phone-sales/optimized/db-life-smart-phone-sales-img-02-04@w.jpg
// module id = 6UBa
// module chunks = 0